import { Component, OnInit, OnDestroy, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, InputComponent, QueryParameter, NumberInputComponentV3, UserService, ModalService, NotificationService } from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { FakDokumentUplata } from './fak-dokument-uplata';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { List } from 'immutable';
import { PodVrstaDokumentaStavkaView } from 'src/app/lookups/podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-view';
import { Validators } from '@angular/forms';

@Component({
    selector: 'yt-fak-dokument-uplata-update',
    templateUrl: './fak-dokument-uplata-update.component.html'
})
export class FakDokumentUplataUpdateComponent
    extends BaseUpdateComponent<FakDokumentUplata>
    implements OnInit, OnDestroy {

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected decimalPipe: DecimalPipe,
        protected userService: UserService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected modalService: ModalService
    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.addValidatorToFc('RB', Validators.required, 'required', 'IZVODSTAVKA.RB.VALIDATION.REQUIRED');
        this.addValidatorToFc('Broj', Validators.required, 'required', 'IZVODSTAVKA.BROJ.VALIDATION.REQUIRED');
        this.addValidatorToFc('PodVrstaDokumentaStavkaID', Validators.required, 'required', 'IZVODSTAVKA.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED');
        this.addValidatorToFc('Datum', Validators.required, 'required', 'IZVODSTAVKA.DATUM.VALIDATION.REQUIRED');
        this.addValidatorToFc('Iznos', Validators.required, 'required', 'IZVODSTAVKA.IZNOS.VALIDATION.REQUIRED');

        this.IDProcessed
            .subscribe(value => { 
              if (value)
                if (this.Item.ID == -1 && this.Parameters != undefined) {
                    this.baseFormGroup.patchValue({ RB: this.Parameters.get(0).get(0).Value });
                    this.baseFormGroup.get('RB').updateValueAndValidity();
                    // if (this.defaultOrgJedID)
                    // {
                    //   this.baseFormGroup.patchValue({ OrgJedID: this.defaultOrgJedID });
                    //   this.baseFormGroup.get('OrgJedID').updateValueAndValidity();
                    // }
                }

                if (this.Item.ID === -1) {
                     const today = new Date();
                     const ngbDateStruct = {
                        year: today.getFullYear(),
                        month: today.getMonth() + 1,
                        day: today.getDate()
                     };

                this.baseFormGroup.get('Datum').patchValue(ngbDateStruct);
                this.baseFormGroup.get('Datum').updateValueAndValidity();

                }
            })
 
  }    
    

    PodVrstaDokumentaStavkaGetParameters: List<QueryParameter> = List([
        new QueryParameter('url', '/fin/Izvod')
    ]);
      
    onDatumChange(value) {
        if (value != null) {
            this.getBrojDokumenta();
            this.getRBDokumenta();
        }
    }

    onPodVrstaSelect() {
        this.getBrojDokumenta();
        this.getRBDokumenta();
    }

    getBrojDokumenta() {
        let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
        let datum = this.baseFormGroup.get('Datum').value;
        let _this = this;
        if (podvrstaid && datum)
            this.baseDataService.GetData('Izvod', 'GetUplataByBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
                .subscribe(data => {
                    if (_this.baseFormGroup.get('Datum').value){
                        this.baseFormGroup.patchValue({ Broj: data });
                        this.baseFormGroup.get('Broj').updateValueAndValidity();
                    }
            })
    }

    getRBDokumenta(){
        let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
        let datum = this.baseFormGroup.get('Datum').value;
        let _this = this;
        if (this.Item.ID == -1 && podvrstaid && datum)
            this.baseDataService.GetData('IzvodStavka', 'KreirajRBDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
                .subscribe(data => {
                    if (_this.baseFormGroup.get('Datum').value){
                        this.baseFormGroup.patchValue({ RB: data });
                        this.baseFormGroup.get('RB').updateValueAndValidity();
                    }
            })       
    }

}

